import { render, staticRenderFns } from "./SelectPayMethod.vue?vue&type=template&id=60cff27e&scoped=true"
import script from "./SelectPayMethod.vue?vue&type=script&lang=js"
export * from "./SelectPayMethod.vue?vue&type=script&lang=js"
import style0 from "./SelectPayMethod.vue?vue&type=style&index=0&id=60cff27e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cff27e",
  null
  
)

export default component.exports